const SafetyIconSafetyFootwear = ({
  className,
}: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M23 16.5455H20.1429V11.4545C20.1429 11.0688 19.9923 10.6988 19.7244 10.426C19.4565 10.1532 19.0932 10 18.7143 10H8.71429C8.59847 10 8.48439 10.0287 8.38189 10.0836C8.27939 10.1385 8.19153 10.218 8.1259 10.3151C8.06026 10.4123 8.01881 10.5242 8.00512 10.6413C7.99143 10.7584 8.00592 10.8771 8.04732 10.9873C9.03482 13.6091 8.82946 18.5973 8.02768 21.4355C8.00961 21.5008 8.0003 21.5684 8 21.6364V24.5455C8 24.9312 8.15051 25.3012 8.41842 25.574C8.68633 25.8468 9.04969 26 9.42857 26H11.7598C11.9817 26 12.2006 25.9474 12.3991 25.8464L13.5259 25.2727H14.9741L16.1009 25.8464C16.2994 25.9474 16.5183 26 16.7402 26H19.2598C19.4817 26 19.7006 25.9474 19.8991 25.8464L21.0259 25.2727H22.4741L23.6009 25.8464C23.7994 25.9474 24.0183 26 24.2402 26H26.5714C26.9503 26 27.3137 25.8468 27.5816 25.574C27.8495 25.3012 28 24.9312 28 24.5455V21.6364C27.9986 20.2866 27.4713 18.9926 26.534 18.0381C25.5966 17.0837 24.3256 16.5469 23 16.5455ZM9.68393 11.4545H18.7143V13.6364H15.8571C15.6677 13.6364 15.486 13.713 15.3521 13.8494C15.2181 13.9858 15.1429 14.1708 15.1429 14.3636C15.1429 14.5565 15.2181 14.7415 15.3521 14.8779C15.486 15.0143 15.6677 15.0909 15.8571 15.0909H18.7143V16.5455H15.8571C15.6677 16.5455 15.486 16.6221 15.3521 16.7585C15.2181 16.8949 15.1429 17.0798 15.1429 17.2727C15.1429 17.4656 15.2181 17.6506 15.3521 17.787C15.486 17.9234 15.6677 18 15.8571 18H23C23.823 18.001 24.6205 18.2909 25.2581 18.8208C25.8956 19.3508 26.3342 20.0883 26.5 20.9091H9.62946C10.2321 18.1055 10.358 14.1664 9.68393 11.4545ZM26.5714 24.5455H24.2402L23.1134 23.9718C22.9149 23.8707 22.696 23.8181 22.4741 23.8182H21.0259C20.804 23.8181 20.5851 23.8707 20.3866 23.9718L19.2598 24.5455H16.7402L15.6134 23.9718C15.4149 23.8707 15.196 23.8181 14.9741 23.8182H13.5259C13.304 23.8181 13.0851 23.8707 12.8866 23.9718L11.7598 24.5455H9.42857V22.3636H26.5714V24.5455Z"
      fill="#171717"
    />
  </svg>
)

export default SafetyIconSafetyFootwear
